import { memo } from 'react';
import CampaignCard from './campaign-card';

export type RealCampaignStatus = 'Pending' | 'Running' | 'Paused' | 'Completed' | 'Aborted';

type Props = {
    itemId: string;
    index: number;
};

function CampaignDialogRow({ itemId: campaignId, index }: Props) {
    return (
        <div className="mb-4">
            <CampaignCard campaignId={campaignId} />
        </div>
    );
}

export default memo(CampaignDialogRow);